import TxnPageBody from "./TxnPageBody"
import { useParams } from "react-router-dom"

export default function TxnPage() {
  const { txnId } = useParams()

  return(
    <div className="flex flex-col overflow-y-auto w-full grow lg:justify-center">
      <TxnPageBody txnId={txnId} />
    </div>
  )
}